module.exports = __webpack_public_path__ + "static/media/shopping-cart-icon.0a65e458.svg";